import Box from '@mui/material/Box'
import { ApexOptions } from 'apexcharts'
import ReactApexChart from 'react-apexcharts'

interface IDonutProps {
	colors: string[]
	categories: number[]
	labels?: string[]
	width?: string
	height?: string
}

const DonutChart = (props: IDonutProps) => {
	const {
		categories = [],
		colors = [],
		width = '100%',
		height = '100%',
	} = props

	const isEmptyChart =
		!categories || categories.length === 0 || categories.every(el => el === 0)

	const chartColors = isEmptyChart ? ['#F7F7F7'] : colors
	const chartSeries = isEmptyChart ? [1] : categories

	const options: ApexOptions = {
		chart: {
			type: 'donut',
		},
		dataLabels: { enabled: false },
		plotOptions: {
			pie: {
				expandOnClick: false,
				donut: {
					labels: {
						show: false,
						name: { show: false },
						value: { show: false },
						total: { show: false, showAlways: false },
					},
					size: '50%',
					background: 'transparent',
				},
			},
		},
		states: {
			hover: {
				filter: {
					type: 'none',
				},
			},
			active: {
				allowMultipleDataPointsSelection: false,
				filter: {
					type: 'none',
				},
			},
		},
		stroke: {
			show: false,
		},
		colors: chartColors,
		legend: {
			show: false,
		},
		tooltip: {
			enabled: false,
		},
	}

	return (
		<Box
			width={'40%'}
			marginLeft='-20px'
			// sx={{
			// 	'@media (max-width: 1200px)': {
			// 		width: '75%',
			// 	},
			// }}
		>
			<ReactApexChart
				height={height}
				width={width}
				type='donut'
				options={options}
				series={chartSeries}
			/>
		</Box>
	)
}

export default DonutChart
